import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityWorkEmbedRoute: InvariantJiraRoute = {
	name: 'software-capacity-work-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/work/embed',
	query: [],
};
